import React from "react";
import { useDashboardTheme } from "@/pages/MeetingDashboard/themeHelper";

interface CustomLogoutDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CustomLogoutDialog: React.FC<CustomLogoutDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { colors } = useDashboardTheme();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/40 transition-all duration-200">
      <div
        className="rounded-2xl p-6 w-[90%] max-w-sm shadow-2xl transition-all duration-200"
        style={{
          background: colors.surface,
          border: `1px solid ${colors.border}`,
          color: colors.text,
        }}
      >
        <h2 className="text-xl font-bold mb-2 text-center" style={{ color: colors.text }}>
          Logout Confirmation
        </h2>
        <p className="text-sm text-center mb-6" style={{ color: colors.textMuted }}>
          Are you sure you want to log out from your account?
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={onClose}
            className="px-5 py-2 text-sm font-semibold cursor-pointer rounded-xl transition-all"
            style={{
              background: colors.surfaceAlt,
              border: `1px solid ${colors.border}`,
              color: colors.text,
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2 text-sm font-semibold cursor-pointer rounded-xl bg-red-600 hover:bg-red-700 text-white transition-all shadow-md active:scale-95"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomLogoutDialog;
